import { BoldTextButton } from "thrive-components";
import { getCommentReplyTitle } from "../notificationTitles.service";


export interface ICommentReplyTitle {
    content: {
        id: number;
        title: string;
        link: string;
        isArchived: boolean;
        existsInMultiplePlaces: boolean;
    };
    user: string;
    commentAuthor?: string;
    isPopOut?: boolean
}

const CommentReplyTitle = ({content, user, commentAuthor, isPopOut}: ICommentReplyTitle ) => {
    const {className, activityInformation, contentLinkAriaLabel, contentLink, contentLinkTitle} = getCommentReplyTitle({content, user, commentAuthor, isPopOut})
    
    return (
        <span className={className}>
            {activityInformation}

            <BoldTextButton
                ariaLabel={contentLinkAriaLabel}
                link={contentLink}
                text={contentLinkTitle}
            />
        </span>
    );
};
export default CommentReplyTitle;
